<template>
  <d-modal v-if="orderKey !== null" @close="handleClose">
    <d-modal-header>
      <d-modal-title>Confirm Void</d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <p>Voiding an order cannot be undone.<p>
      <p>To enable the confirm void button, please type the following code:</p>
      <pre class="text-danger" style="font-size: 1.2rem">{{confirmTest}}</pre>
      <d-form-input :state="confirmValueState" type="text" placeholder="confirm" class="mb-2" v-model="confirmValue"></d-form-input>
    </d-modal-body>
    <d-modal-footer>
      <d-button class="mx-2" theme="light" @click="handleClose">
        Cancel
      </d-button>
      <async-button
        :disabled="confirmValueState !== true"
        @click="voidOrder"
        text="Void"
        loadingText="voiding..."
        theme="danger"
        :loading="voiding"
      />
    </d-modal-footer>
  </d-modal>
</template>

<script>

export default {
  data() {
    return {
      loading: true,
      voiding: false,
      confirmValue: '',
    };
  },
  props: {
    orderKey: {
      type: String,
      default: null
    }
  },
  computed: {
    confirmTest() {
      return this.orderKey.substring(0,5)
    },
    confirmValueState() {
      return this.confirmValue === this.confirmTest ? true: undefined
    }
  } ,
  watch: {
    orderKey(newValue) {
      this.confirmValue = '';
      if (newValue !== null) {
        this.loading = true;
        this.$store.dispatch("orders/get", newValue).then(order => {
          this.selected = order.order_status;
          this.loading = false;
        });
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit("close", false);
    },
    voidOrder() {
      this.voiding = true;
      this.$store.dispatch("orders/voidOrder", this.orderKey).then(updatedOrder => {
        this.voiding = false;
        this.$emit("close", true);
      });

    }
  }
};
</script>

<style></style>
